import axios from 'axios'
import * as auth from '@store/auth/auth'
import Config from '@app/config'
import jwt_decode from 'jwt-decode'
import OAuthConfig from '@app/config'

const MAX_TIMEOUT = 15000

class ApiError extends Error {
  code: number
  data: any
  constructor(message: string, code: number, data?: any) {
    super(message)
    this.code = code
    this.data = data
  }
}

const execute = <T>(
  path: string,
  method: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH',
  body?: any,
  responseType?: 'arraybuffer'
): Promise<T> => {
  const tokens = auth.store.getState().OAuth
  const { SERVER_PREFIX } = OAuthConfig.AUTH_CONFIG['INTERNAL']

  if (tokens && tokens.expire_at < new Date().getTime()) {
    auth.actions.resetTokens()
    return Promise.reject('Expiration token')
  }

  if (!tokens) {
    Promise.reject('Missing tokens')
  }

  const decrypted_token: { email: string } | undefined =
    (Config.env === 'debug' || Config.env === 'intma') && tokens ? jwt_decode(tokens.id_token) : undefined
  const email = decrypted_token && (decrypted_token.email as string)

  const headers: { [key: string]: string } = email
    ? {
        'content-type': 'application/json',
        'X-Email': email,
      }
    : tokens
    ? {
        'content-type': 'application/json',
        Authorization: `Bearer ${tokens.access_token}`,
        'User-info': tokens.id_token,
      }
    : {
        'content-type': 'application/json',
      }

  // cancel Token used for Timeout
  const cancelToken = axios.CancelToken.source()
  setTimeout(cancelToken.cancel, MAX_TIMEOUT)

  return axios
    .request<T>({
      cancelToken: cancelToken.token,
      url: SERVER_PREFIX + path,
      method: method || (body ? 'POST' : 'GET'),
      headers,
      data: body ? JSON.stringify(body) : undefined,
      timeout: MAX_TIMEOUT,
      responseType,
    })
    .then((res) => {
      if (responseType === 'arraybuffer') {
        return `data:${res.headers['content-type']};base64,${Buffer.from(
          res.data as unknown as string,
          'binary'
        ).toString('base64')}` as unknown as T
      }

      return res.data
    })
    .catch((err) => {
      if (err.response) {
        const { status, data, statusText } = err.response

        if (status >= 400) {
          // Query or Server Error
          throw new ApiError('Unable to query ' + path + ' : ' + status + ' / ' + statusText, status, data)
        }
      }

      // eslint-disable-next-line no-console
      console.error('Network error')
      // Network error (no internet, server down, ...)
      throw err
    })
}

export default execute
